/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Translatable messages used in backpack.
 * @author kozbial@google.com (Monica Kozbial)
 */

import * as Blockly from 'blockly/core';

// context menu - Copy all Blocks on the workspace to the backpack.
Blockly.Msg['COPY_ALL_TO_BACKPACK'] = 'Copy All Blocks to Backpack';
// context menu - Copy the selected Block to the backpack.
Blockly.Msg['COPY_TO_BACKPACK'] = 'Copy to Backpack';
// context menu - Empty the backpack.
Blockly.Msg['EMPTY_BACKPACK'] = 'Empty';
// context menu - Paste all Blocks from the backpack to the workspace.
Blockly.Msg['PASTE_ALL_FROM_BACKPACK'] = 'Paste All Blocks from Backpack';
// context menu - Remove the selected Block from the backpack.
Blockly.Msg['REMOVE_FROM_BACKPACK'] = 'Remove from Backpack';
